var map = {
	"./da-DK/common": 67916,
	"./da-DK/common.json": 67916,
	"./da-DK/seo": 18428,
	"./da-DK/seo.json": 18428,
	"./da-DK/unit": 35154,
	"./da-DK/unit.json": 35154,
	"./en/common": 1807,
	"./en/common.json": 1807,
	"./en/seo": 63351,
	"./en/seo.json": 63351,
	"./en/unit": 3891,
	"./en/unit.json": 3891
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84809;